const {
  getValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate getTransientContextBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const path = await evaluateSource(source.path, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof path !== 'string') {
    return undefined;
  }
  const value = path.length ? getValue(path, transientContext) : transientContext;
  return evaluateSource(value, content, parentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};